import { render, staticRenderFns } from "./agreementItem.vue?vue&type=template&id=84326474&scoped=true"
import script from "./agreementItem.vue?vue&type=script&lang=js"
export * from "./agreementItem.vue?vue&type=script&lang=js"
import style0 from "./agreementItem.vue?vue&type=style&index=0&id=84326474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84326474",
  null
  
)

export default component.exports